export const DEFAULT_INSTAGRAM_METRIC_1 = ['igFollowersCount'];
export const DEFAULT_INSTAGRAM_METRIC_2 = ['igAvgFeedReachEngRate'];
export const DEFAULT_INSTAGRAM_METRIC_3 = ['igAvgFeedReach', 'igAvgStoryReach'];

export const POST_ASPECT_RATIO = 1;
